/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1SerievideoSeriesSerieid200,
  GetApiV1SerievideoSeriesSerieid401,
  GetApiV1SerievideoSeriesSerieid404,
  GetApiV1SerievideoSeriesSerieid500,
  GetApiV1SerievideoSeriesSerieidPathParams,
  GetApiV1SerievideoSeriesSerieidQueryParams,
  GetApiV1SerievideoSeriesSerieidQueryResponse,
} from "../../types/serieVideoRegistroController/GetApiV1SerievideoSeriesSerieid.ts";
import { eCompanyFilterTypeSchema } from "../eCompanyFilterTypeSchema.ts";
import { serieVideoGridItemViewModelPaginatedResponseSchema } from "../serieVideoGridItemViewModelPaginatedResponseSchema.ts";

export const getApiV1SerievideoSeriesSerieidPathParamsSchema = z.object({
  serieId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1SerievideoSeriesSerieidPathParams>;

export const getApiV1SerievideoSeriesSerieidQueryParamsSchema = z.object({
  filter: z.optional(
    z
      .lazy(() => eCompanyFilterTypeSchema)
      .describe("1 = Main | 2 = Company | 3 = All | "),
  ),
  search: z.optional(z.string()),
  page: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1SerievideoSeriesSerieidQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1SerievideoSeriesSerieid200Schema = z.lazy(
  () => serieVideoGridItemViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1SerievideoSeriesSerieid200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1SerievideoSeriesSerieid401Schema =
  z.any() as unknown as ToZod<GetApiV1SerievideoSeriesSerieid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1SerievideoSeriesSerieid404Schema =
  z.any() as unknown as ToZod<GetApiV1SerievideoSeriesSerieid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1SerievideoSeriesSerieid500Schema =
  z.any() as unknown as ToZod<GetApiV1SerievideoSeriesSerieid500>;

export const getApiV1SerievideoSeriesSerieidQueryResponseSchema = z.lazy(
  () => getApiV1SerievideoSeriesSerieid200Schema,
) as unknown as ToZod<GetApiV1SerievideoSeriesSerieidQueryResponse>;
